import { createApp } from "vue";
import App from "./App.vue";

import NewsTip from './views/NewsTip.vue';
import DataSafety from './views/DataSafety.vue';

import UGC from './views/UGC.vue';

import { createRouter, createWebHistory } from 'vue-router';

import { VueRecaptchaPlugin } from 'vue-recaptcha';
import { createHead } from "@unhead/vue";

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faImage, faFileVideo, faTrashCan } from '@fortawesome/free-solid-svg-icons'

library.add(faCheck, faImage, faFileVideo, faTrashCan)

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/', component: NewsTip },
        { path: '/data-safety', component: DataSafety },
        { path: '/ugc', component: UGC },
    ]
});

const app = createApp(App)
    .component('font-awesome-icon', FontAwesomeIcon);
const head = createHead();

app.use(head);
app.use(router);

app.use(VueRecaptchaPlugin, {
    v3SiteKey: '6LfBb9UmAAAAANTZPQqdRE5nVLjhTawo1RBE3MeW',
});

app.mount("#app");